import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import getHeadersformdata from './getHeaderFormdata'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { notify } from '../services/notification'

//Pincode List Action
export const pincodelistAction = (parm) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.GET_PINCODE + "?pincode=" + parm
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {

      dispatch({ type: types.GET_PINCODE_LIST, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

// Get Pincode Master List with pagination and search
export const getPincodeMasterListAction = (page, pageSize, query = '') => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.PINCODE_MASTER_LIST}?page_size=${pageSize}&page=${page}${query}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_PINCODE_MASTER_LIST, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Download Pincode Master List Excel file
export const downloadPincodeMasterExcelAction = (query = '') => async (dispatch) => {
  const url = `${process.env.REACT_APP_API_URL}${Url.PINCODE_MASTER_DOWNLOAD}${query ? `?${query}` : ''}`;
  const headers = getHeaders();

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (response.status === 200) {
      const blob = await response.blob();
      return blob;
    } else {
      notify.error('Failed to download file');
      return null;
    }
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

// Upload Pincode Master Excel
export const uploadPincodeMasterAction = (formData) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + Url.PINCODE_MASTER_CREATE;
  let options = {
    method: 'POST',
    data: formData,
    headers: getHeadersformdata(),
    url: url
  };

  try {
    const response = await axios(options);
    if (response?.status === 200 || response?.status === 201) {
      dispatch({ type: types.UPLOAD_PINCODE_MASTER, payload: response });
      return response;
    } else {
      return null;
    }
  } catch (error) {
    if (error?.response) {
      if (error?.response?.status === 400) {
        const errorData = error?.response?.data?.errors;
        if (errorData) {
          errorData?.map(i => notify.error(i));
        }
        return error.response;
      } else {
        errorHandler(error);
      }
    } else {
      errorHandler(error);
    }
  }
};

// Get Pincode Upload Logs
export const getPincodeUploadLogsAction = (page, page_size, query) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.PINCODE_MASTER_LOGS +
    `?page_size=${page_size}&page=${page}${query ? query : ""}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_PINCODE_UPLOAD_LOGS, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
    });
};

// Get Pincode Upload Error Details
export const getPincodeUploadLogsDetailsAction = (pincode_master_file_id = null) => dispatch => {
  const baseUrl = process.env.REACT_APP_API_URL + Url.PINCODE_MASTER_LOGS_DETAILS;
  const url = pincode_master_file_id ? `${baseUrl}/${pincode_master_file_id}` : baseUrl;

  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_PINCODE_UPLOAD_LOGS_DETAILS, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Download Pincode Error Report
export const downloadPincodeErrorReportAction = (pincode_master_file_id) => async (dispatch) => {
  const url = `${process.env.REACT_APP_API_URL}${Url.PINCODE_MASTER_ERROR_DOWNLOAD}/${pincode_master_file_id}`;
  const headers = getHeaders();

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (response.status === 200) {
      const blob = await response.blob();
      return { blob, responseHeaders: response.headers };
    } else {
      notify.error('Failed to download error report');
      return null;
    }
  } catch (error) {
    errorHandler(error);
  }
};